module.exports = __webpack_public_path__ + "img/logo-erling.b6d42871.png";